import { render } from "./GamificationProfile.vue?vue&type=template&id=6e99888b"
import script from "./GamificationProfile.vue?vue&type=script&lang=js"
export * from "./GamificationProfile.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__